import {isFeatureEnabled} from '@github-ui/feature-flags'

interface DiffImplementation {
  version: 'v1' | 'v2'
  virtualized: boolean
}

export function getCurrentDiffImplementation(virtualizeDiffEntries: boolean): DiffImplementation {
  const isDiffVirtualizationFlagWithoutMinThresholdEnabled = isFeatureEnabled(
    'pull_request_files_virtualization_without_min_threshold',
  )

  const isVirtualized = (isDiffVirtualizationFlagWithoutMinThresholdEnabled || virtualizeDiffEntries) ?? false

  return {
    version: 'v2',
    virtualized: isVirtualized,
  }
}
